import orderBy from 'lodash/orderBy';
import groupBy from 'lodash/groupBy';
import { useMemo } from 'react';

export const useSortAndCategorizeTemplate = (
  templates,
  { sort = 'asc', categoryBy = 'isActive', sortBy = 'name', shouldGroup = false }
) => {
  if (!Array.isArray(templates)) {
    return [];
  }

  const grouped = groupBy(templates, categoryBy);

  const sortedGrouped = Object.keys(grouped).reduce((acc, key) => {
    acc[key] = orderBy(grouped[key], [sortBy], [sort]);
    return acc;
  }, {});

  return useMemo(() => {
    if (shouldGroup) {
      return sortedGrouped;
    }
    return Object.entries(sortedGrouped)
      .map(([, groupedValue]) => groupedValue)
      .flat();
  }, [sortedGrouped, shouldGroup]);
};
